<template>
    <div class="donation">
      <div class="donation_inner">
        <van-notice-bar left-icon="volume-o" :scrollable="false">
          <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <van-swipe-item v-for="(item,index) in news" :key="index">{{item.certTitle+"捐赠了"+item.amount+"元"}}</van-swipe-item>
          </van-swipe>
        </van-notice-bar>
        <div class="donation_notice">
          母校的每一步发展，都离不开广大校友的关心与支持。您的每一份心意，都将汇入天津中国民航大学教育发展基金会，专项用于学校教育事业发展。感谢您以这样的方式，继续与母校同向同行。
        </div>
        <div class="title_box">
          <div class="alert1">请填写捐款信息</div>
          <div class="alert2">填写并核对捐款信息，再提交支付</div>
          <!--<van-image-->
            <!--round-->
            <!--width="60px"-->
            <!--height="60px"-->
            <!--:src="userInfo.headimgurl"-->
          <!--/>-->
          <!--<div class="title">填写捐款单</div>-->
        </div>
        <div class="money_box">
          <div class="money_title">选择捐款金额</div>
          <div class="money_list">
            <div
              class="money_item"
              :class="index==tabIndex?'selected':''"
              v-for="(item,index) in money"
              @click="handleTab(index)"
              :key="index">{{item+"元"}}
            </div>
          </div>
          <div class="money_input_box">
            <van-field v-model="form.amount" placeholder="请自行输入捐款金额" @click="handleInput"/>
            <div class="money_unit">元</div>
          </div>
        </div>
        <div class="payWay">
          <div class="pay_title">支付方式</div>
          <div class="pay_icons">
            <div class="weixin">
              <img src="@/assets/pay_weixin_icon.png" alt="">
              <div>微信</div>
            </div>
            <img class="pay_select" src="@/assets/payway_select_icon.png" alt="">
          </div>
        </div>
        <div class="send_message">
          <div class="message_title border-left">捐赠寄语</div>
          <van-field
            v-model="form.blessing"
            rows="4"
            autosize
            label=""
            type="textarea"
            maxlength="80"
            placeholder="请输入捐款寄语"
            show-word-limit
          />
        </div>
        <div class="add_message">
          <div class="message_title border-left">完善信息</div>
          <div class="anonymity">
            <div class="anonymity_des">
              <div class="part1">匿名捐赠</div>
              <div class="part2">匿名捐赠将不对外公开姓名</div>
            </div>
            <van-switch v-model="form.anonymous" active-color="#0067DD" inactive-color="#dcdee0" size="24px"/>
          </div>
          <div class="common_item">
            <div class="item_title">姓名/团体名称<span class="require">*</span></div>
            <div class="input_box">
              <van-field v-model="form.certTitle" placeholder="请填写真实姓名/团体名称"/>
            </div>
          </div>
          <!--<div class="common_item">-->
            <!--<div class="item_title">称谓</div>-->
            <!--<van-radio-group v-model="form.sex" direction="horizontal">-->
              <!--<van-radio name="1" checked-color="#0067DD">先生</van-radio>-->
              <!--<van-radio name="2" checked-color="#0067DD">女士</van-radio>-->
            <!--</van-radio-group>-->
          <!--</div>-->
          <div class="common_item">
            <div class="item_title">手机<span class="require">*</span></div>
            <div class="input_box">
              <van-field v-model="form.mobile" type="tel" placeholder="请仅填写数字"/>
            </div>
          </div>
          <!--<div class="common_item">-->
            <!--<div class="item_title">工作单位</div>-->
            <!--<div class="input_box">-->
              <!--<van-field v-model="form.company" placeholder="请填写您所在的工作单位"/>-->
            <!--</div>-->
          <!--</div>-->
          <div class="common_item">
            <div class="item_title">入学年<span class="subtitle">(非中航大校友无需填写)</span></div>
            <div class="input_box">
              <van-field v-model="form.year" placeholder="请选择您的入学年份" readonly @click="handleYear" />
            </div>
          </div>
          <div class="common_item">
            <div class="item_title">院系/专业<span class="subtitle">(非中航大校友无需填写)</span></div>
            <div class="input_box">
              <van-field v-model="form.deptMajor" placeholder="请填写院系/专业"/>
            </div>
          </div>
        </div>
        <div class="foot_message">
          <div class="bill">
            <div class="bill_des">
              <div class="part1 border-left">是否需要捐赠票据</div>
              <div class="part2">（开具票据后，我们将通过电话与您联系）</div>
            </div>
            <van-switch v-model="form.ticket" active-color="#0067DD" inactive-color="#dcdee0" size="24px"
                        @change="handleBillChange"/>
          </div>
          <div class="common_item" v-if="form.ticket">
            <div class="item_title">票据抬头<span class="require">*</span></div>
            <div class="input_box">
              <van-field v-model="form.tktTitle" placeholder="请填写您的姓名或单位名称"/>
            </div>
          </div>
          <div class="common_item" v-if="form.ticket">
            <div class="item_title">税号</div>
            <div class="input_box">
              <van-field v-model="form.taxNo" placeholder="纳税人识别号"/>
            </div>
          </div>
        </div>
        <div class="pay_box">
          <div class="pay_commit" @click="commit">立即支付</div>
        </div>
      </div>
        <van-popup v-model="showPickerY" position="bottom">
            <van-datetime-picker
                    :type="yearType"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    title="选择入学年份"
                    @cancel="onCancel"
                    @confirm="onConfirmTime"/>
        </van-popup>
    </div>
</template>

<script>
import { Dialog } from 'vant'
import {weixinConfig, isSuccessPay, donationNews} from '../../utils/ajaxInterface'
import wexinPay from '../../utils/weixinpay'
export default {
  name: 'index',
  data () {
    return {
      news: [],
      userInfo: {},
      showPickerY: false,
      yearType: 'year-month',
      minDate: new Date(1951, 0, 1),
      currentDate: new Date(),
      maxDate: new Date(2026, 11, 31),
      form: {
        amount: '',
        blessing: '',
        anonymous: false,
        certTitle: '',
        sex: '1',
        mobile: '',
        company: '',
        year: '',
        deptMajor: '',
        ticket: true,
        taxNo: '',
        tktTitle: ''
      },
      tabIndex: 0,
      money: ['9.9', '20', '50', '100', '200', '500']
    }
  },
  created () {
    // document.title = '捐款'
    this.getInfo()
    this.getDonations()
  },
  methods: {
    getDonations () {
      donationNews().then(res => {
        this.news = res
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    getInfo () {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.userInfo = userInfo
    },
    onCancel () {
      this.showPickerY = false
    },
    // 选择计分年度
    onConfirmTime (val) {
      // 将字符串转换为Date对象
      var date = new Date(val)
      // 使用getFullYear()方法获取年份
      this.form.year = date.getFullYear()
      this.showPickerY = false
    },
    handleYear () {
      this.showPickerY = true

      this.$nextTick(() => {
        if (this.yearType === 'year-month') {
          // 删除月份列
          let columns = this.$el.querySelectorAll('.van-picker__columns .van-picker-column')
          if (columns.length === 2) {
            columns[1].parentElement.removeChild(columns[1])
          }
        }
      })
    },
    handleBillChange () {
      this.form.taxNo = ''
    },
    commit () {
      if (this.tabIndex == -1 && !this.form.amount) {
        Dialog.alert({
          title: '提示',
          message: '请自行输入捐款金额'
        })
        return false
      }
      if (!this.form.certTitle) {
        Dialog.alert({
          title: '提示',
          message: '请输入姓名/团体名称'
        })
        return false
      }
      if (!this.form.mobile) {
        Dialog.alert({
          title: '提示',
          message: '请输入手机号'
        })
        return false
      }
      if (!this.form.tktTitle && this.form.ticket) {
        Dialog.alert({
          title: '提示',
          message: '请输入票据抬头'
        })
        return false
      }
      let params = JSON.parse(JSON.stringify(this.form))
      if (this.form.anonymous) {
        delete params.mobile
      }
      if (!this.form.ticket) {
        delete params.taxNo
        params.tktTitle = ''
      }
      if (this.tabIndex >= 0) {
        params.amount = this.money[this.tabIndex]
      }
      this.$toast.loading({
        forbidClick: true,
        duration: 0 // 持续展示
      })
      weixinConfig(params).then(data => {
        this.$toast.loading(false)
        wexinPay(data, (res) => {
          // 支付成功为确保真的成功，调用接口判断
          setTimeout(() => {
            isSuccessPay({tradeNo: data.tradeNo}).then(re => {
              if (re.tradeState === 'SUCCESS') {
                this.$toast.success(re.tradeStateDesc)
                this.$router.push('/donationDetail')
              } else {
                this.$toast.fail(re.tradeStateDesc)
              }
            }).catch(e => {
              this.$toast.fail(e)
            })
          }, 1000)
        })
      }).catch(e => {
        this.$toast.loading(false)
        this.$toast.fail(e)
      })
    },
    handleInput () {
      this.tabIndex = -1
    },
    handleTab (index) {
      this.tabIndex = index
      this.form.amount = ''
    }
  }
}
</script>
<style lang="less" scoped>
    .donation {
        background-color: #F6F8FA;
        background: url("../../assets/donation_bg_new.png") no-repeat center top;
      background-size: 100% auto;
        min-height: 100vh;
      .border-left{
        border-left: 4px solid;
        border-image: linear-gradient(180deg, #0067DD 0%, #1891FE 100%) 1;
        padding-left: 6px;
        height: 20px;
        line-height: 22px;
      }
      .donation_inner{
        padding: 10px 16px 110px;
        box-sizing: border-box;
        .notice-swipe {
          height: 40px;
          line-height: 40px;
        }
        .head_alert {
          width: 100%;
          height: 36px;
          background: #FFF4D1;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 18px;
            height: 18px;
            margin-right: 11px;
          }

          .trumpet {
            font-weight: 400;
            font-size: 12px;
            color: #C29935;
          }
        }
        .donation_notice{
          margin: 10px 0 0;
          text-indent: 28px;
          font-size: 14px;
          color: #ffffff;
        }
        .title_box {
          margin-top: 12px;
          .alert1{
            font-size: 20px;
            color: #FFFFFF;
          }
          .alert2{
            font-size: 11px;
            color: #FFFFFF;
            margin: 4px 0 10px;
          }
          /*width: 100%;*/
          /*height: 90px;*/
          /*background: url("../../assets/donation_title_bg.png") no-repeat center center;*/
          /*background-size: 100% 100%;*/
          /*display: flex;*/
          /*padding-left: 16px;*/
          /*box-sizing: border-box;*/
          /*align-items: center;*/
          /*margin-top: 12px;*/

          /*img {*/
            /*width: 48px;*/
            /*height: 48px;*/
          /*}*/

          /*.title {*/
            /*margin-left: 20px;*/
            /*font-weight: 400;*/
            /*font-size: 16px;*/
            /*color: #111111;*/
          /*}*/
        }

        .money_box {
          width: 100%;
          height: 221px;
          background: #FFFFFF;
          padding: 10px 16px 0;
          box-sizing: border-box;
          margin-bottom: 12px;

          .money_title {
            font-weight: 400;
            font-size: 16px;
            color: #111111;
            margin-bottom: 10px;
          }

          .money_list {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .money_item {
              width: 32%;
              height: 48px;
              line-height: 48px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid #D0D2D2;
              font-size: 16px;
              color: #929292;
              margin-bottom: 8px;
            }

            .selected {
              border: 1px solid #0067DD;
              color: #0067DD;
            }
          }

          .money_input_box {
            width: 100%;
            height: 48px;
            background: #F3F5F7;
            border-radius: 4px;
            display: flex;
            padding: 0 14px 0 0;
            box-sizing: border-box;
            align-items: center;

            .money_unit {
              width: 40px;
              text-align: right;
            }

            /deep/ .van-cell {
              background-color: transparent;
            }
          }
        }

        .payWay {
          width: 100%;
          height: 85px;
          background: #FFFFFF;
          padding: 14px 15px 0;
          box-sizing: border-box;
          margin-bottom: 12px;

          .pay_title {
            font-size: 16px;
            color: #111111;
            margin-bottom: 12px;
          }

          .pay_icons {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .weixin {
              display: flex;
              align-items: center;
              font-size: 16px;
              color: #333333;

              img {
                width: 24px;
                height: 24px;
                margin-right: 8px;
              }
            }

            .pay_select {
              width: 18px;
              height: 18px;
            }
          }
        }

        .send_message {
          width: 100%;
          height: 206px;
          background: #FFFFFF;
          padding: 12px 16px 0;
          box-sizing: border-box;
          margin-bottom: 12px;

          .message_title {
            font-size: 16px;
            color: #111111;
            margin-bottom: 12px;
          }

          /deep/ .van-cell {
            /*padding: 0;*/
            background: #F3F5F7;
          }
        }

        .add_message {
          width: 100%;
          padding: 12px 16px 15px;
          box-sizing: border-box;
          background: #FFFFFF;

          .message_title {
            font-size: 16px;
            color: #111111;
            margin-bottom: 10px;
          }

          .anonymity {
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;

            .anonymity_des {
              .part1 {
                font-size: 14px;
                color: #0067DD;
                margin-bottom: 8px;
              }

              .part2 {
                font-size: 11px;
                color: #929292;
              }
            }
          }

          .common_item {
            width: 100%;
            margin-bottom: 20px;

            .item_title {
              font-size: 14px;
              color: #111111;
              margin-bottom: 12px;

              .require {
                color: red;
                margin: 0 2px;
              }

              .subtitle {
                color: #929292;
              }
            }

            .input_box {
              width: 100%;
              height: 46px;
              border-radius: 4px;
              border: 1px solid #E7E7E7;
            }
          }
        }

        .foot_message {
          width: 100%;
          padding: 12px 16px 15px;
          box-sizing: border-box;
          background: #FFFFFF;

          .bill {
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;

            .bill_des {
              .part1 {
                font-size: 14px;
                color: #111111;
                margin-bottom: 8px;
              }

              .part2 {
                font-size: 11px;
                color: #929292;
              }
            }
          }

          .common_item {
            width: 100%;
            margin-bottom: 20px;

            .item_title {
              font-size: 14px;
              color: #111111;
              margin-bottom: 12px;

              .require {
                color: red;
                margin: 0 2px;
              }

              .subtitle {
                color: #929292;
              }
            }

            .input_box {
              width: 100%;
              height: 46px;
              border-radius: 4px;
              border: 1px solid #E7E7E7;
            }
          }
        }

        .pay_box {
          position: fixed;
          width: 100%;
          height: 90px;
          left: 0;
          right: 0;
          bottom: 0;
          box-sizing: border-box;
          background: #FFFFFF;
          box-shadow: 0px -4px 37px 0px rgba(186,185,185,0.25);
          padding-top: 14px;
          .pay_commit{
            width: 325px;
            height: 48px;
            background: linear-gradient( 270deg, #0067DD 0%, #66ADFF 100%);
            border-radius: 10px;
            line-height: 48px;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            margin: 0 auto;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/donation/index.vue